import { Button } from "@/components/ui/button";
import Link from "@/components/LocaleLink";
import { useTranslation } from "react-i18next";
import rooftopWorkers from "@/assets/rooftop-workers.jpg";
import BookDemoButton from "@/components/BookDemoButton";
const CTASection = () => {
  const {
    t
  } = useTranslation();
  return <section className="relative bg-[#0a0a0a] text-white">
      {/* Top torn edge */}
      <div className="absolute top-0 left-0 right-0 h-12 overflow-hidden z-10">
        
      </div>

      <div className="pt-24 pb-20 lg:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left content */}
            <div className="space-y-6">
              {/* New feature badge */}
              

              {/* Headline */}
              <h2 className="feature-support-heading text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight">
                {t('cta.tryBanaMind')}
                <br />
                {t('cta.withYourTeam')}
              </h2>

              

              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-4 pt-4">
                <BookDemoButton buttonClassName="px-6 py-6" />
                <Button asChild variant="outline" className="bg-transparent border-2 border-white/30 text-white hover:bg-white/10 font-semibold px-6 py-6 text-base rounded-full">
                  <Link to="/pricing">{t('cta.seePricing')}</Link>
                </Button>
              </div>
            </div>

            {/* Right content - Image */}
            <div className="relative hidden lg:block">
              <div className="relative">
                {/* Curved image container */}
                <div className="overflow-hidden" style={{
                borderRadius: "40% 0 0 40%"
              }}>
                  <img
                    src={rooftopWorkers}
                    alt="Construction workers on rooftop"
                    width={1600}
                    height={900}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-[450px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default CTASection;
